<div
  role="listitem"
  class="flex items-center [&_*]:font-normal [&_*]:!mb-0 [&_*]:text-base mb-1.5 [&_strong]:font-bold text-[--color-text-primary]"
  [ngClass]="{ 'mb-2': isOfferBox(), 'mb-1.5': !isOfferBox() }"
>
  <div class="pr-1.5">
    <lib-svg [svg]="`check-indicator-${brand()}`" />
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</div>
